




































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./train_add.vue";
import Edit from "./train_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "train/list";

  dispatchTypeDelete = "train/delete";

  deleteConfirmContent = "确定要删除该培训机构吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "培训机构名称", dataIndex: "institution_name" },
    { title: "联系人", dataIndex: "user_name" },
    { title: "手机号", dataIndex: "user_mobile" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
